import classNames from 'classnames';

function ZYIcon({
  type,
  style,
  className,
}: {
  className?: string;
  type: string;
  style?: React.CSSProperties;
}) {
  return (
    <svg className={classNames('icon svg-icon', className)} aria-hidden="true" style={style}>
      <use xlinkHref={`#icon-${type}`} />
    </svg>
  );
}

export { ZYIcon };
